/* eslint-disable @typescript-eslint/no-unused-vars */
import Badge from 'components/base/Badge';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import Avatar from 'components/base/Avatar';
import { formatDate, formatTimeToAmPm } from 'services/utils';
import { hrmsPaths } from 'constants/pagePath';
import Button from 'components/base/Button';
import dayjs from 'dayjs';

const CheckManualPunchColumns = ({ handleShowReview }) => [
  {
    accessorKey: 'employee_name',
    id: 'employee_name',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <FeatherIcon
              icon="user"
              size={16}
              className="text-primary-600 dark__text-primary-300"
            />
          </div>
          <span>Name</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const {
        employee_id,
        user_id,
        employee_image,
        employee_name,
        designation_name,
        employee_mobile
      } = original;
      return (
        <div className="d-flex align-items-center">
          <Link to={`${hrmsPaths.employee.detail(user_id)}`}>
            <Avatar src={employee_image} size="xl" className="me-3" />
          </Link>
          <div>
            <Link
              to={`${hrmsPaths.employee.detail(user_id)}`}
              className="fs-8 fw-bold"
            >
              {employee_name}
            </Link>

            <div className="d-flex align-items-center">
              <Link
                className="mb-0 text-1000 fw-semi-bold fs-9 me-2"
                to={`tel: ${employee_mobile}`}
              >
                {employee_mobile}
              </Link>
            </div>

            <div>
              {' '}
              {designation_name ? (
                <Badge variant="phoenix" bg={'primary'}>
                  {designation_name}
                </Badge>
              ) : (
                <Badge variant="phoenix" bg={'secondary'}>
                  No Role
                </Badge>
              )}
            </div>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '10%' }, className: 'ps-0 border-end' },
      cellProps: { className: 'white-space-nowrap ps-0 border-end' }
    }
  },

  {
    accessorKey: 'department_name',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <FeatherIcon
              icon="users"
              size={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Department</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { department_name } = original;
      return (
        <div>
          <div className="fw-normal">{department_name || '--'}</div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: '20%', minWidth: '80px' },
        className: 'ps-3 pe-3 '
      },
      cellProps: {
        className: 'white-space-nowrap fw-semi-bold ps-3 '
      }
    }
  },

  {
    accessorKey: 'shift_name',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-warning-100 rounded me-2">
            <FeatherIcon
              icon="clock"
              size={16}
              className="text-warning-600 dark__text-warning-300"
            />
          </div>
          <span>Shift</span>
        </div>
      );
    },

    cell: ({ row: { original } }) =>
      original.shift_name ? (
        <>
          {original.shift_name} <br />
          <small>
            ({formatTimeToAmPm(original.shift_start_time)} -{' '}
            {formatTimeToAmPm(original.shift_end_time)})
          </small>
        </>
      ) : (
        '--'
      ),
    meta: {
      headerProps: {
        style: { width: '20%' },
        className: 'ps-3 pe-4 '
      },
      cellProps: {
        className: 'white-space-nowrap ps-3  '
      }
    }
  },
  {
    accessorKey: 'punch_in',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-warning-100 rounded me-2">
            <FeatherIcon
              icon="clock"
              size={16}
              className="text-warning-600 dark__text-warning-300"
            />
          </div>
          <span>Punch In</span>
        </div>
      );
    },

    cell: ({ row: { original } }) => (
      <>
        {original.punch_in ? (
          <>
            <div> {formatDate(original.punch_in, 'DD MMM YYYY')}</div>
            <div> {formatDate(original.punch_in, 'hh:mm a')}</div>
          </>
        ) : (
          '--'
        )}
      </>
    ),
    meta: {
      headerProps: {
        style: { width: '15%' },
        className: 'ps-3 pe-4 '
      },
      cellProps: {
        className: 'white-space-nowrap ps-3  '
      }
    }
  },
  {
    accessorKey: 'punch_out',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-warning-100 rounded me-2">
            <FeatherIcon
              icon="clock"
              size={16}
              className="text-warning-600 dark__text-warning-300"
            />
          </div>
          <span>Punch Out</span>
        </div>
      );
    },

    cell: ({ row: { original } }) => (
      <>
        {original.punch_out ? (
          <>
            <div> {formatDate(original.punch_out, 'DD MMM YYYY')}</div>
            <div> {formatDate(original.punch_out, 'hh:mm a')}</div>
          </>
        ) : (
          '--'
        )}
      </>
    ),
    meta: {
      headerProps: {
        style: { width: '15%' },
        className: 'ps-3 pe-4 '
      },
      cellProps: {
        className: 'white-space-nowrap ps-3  '
      }
    }
  },
  {
    id: 'action',
    header: 'Action',
    cell: ({ row: { original } }) => (
      <Button
        variant={`phoenix-primary`}
        className="p-2 fs-9 fw-medium text-nowrap"
        onClick={() => handleShowReview(original)}
      >
        Review
      </Button>
    ),
    meta: {
      headerProps: { style: { width: '7%' }, className: 'text-center' },
      cellProps: { className: 'text-end' }
    }
  }
];

export default CheckManualPunchColumns;
